import { useContext } from 'react';

import { AuthContext } from '@/providers';

function useAuth() {
  return useContext(AuthContext);
}

export default useAuth;
